
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqN6Q8iOaMvZ6_W2UfYfhbFm_ZXDOl_45BOSwFZ1Nzk085sMeta } from "/opt/buildhome/repo/frontend/pages/faq.vue?macro=true";
import { default as indexTKHtD1lM1nWijPiNYDYA0NK2kgXJZ7rYFv1G6ns9_poMeta } from "/opt/buildhome/repo/frontend/pages/index.vue?macro=true";
import { default as quotekmRpIEOXb92wuFy0nNYYmbweRERxJgRGkrXBcFyxr2gMeta } from "/opt/buildhome/repo/frontend/pages/quote.vue?macro=true";
import { default as _91slug_93GuTctvqmfsT6mj_45wrrk3Pjn5jMPsYfqNuVgqlF564oEMeta } from "/opt/buildhome/repo/frontend/pages/[slug].vue?macro=true";
import { default as enquire3Y_xp73_gCKi_PlVWysIJ2HPF6JNJaIJZwvn1g__45fvYMeta } from "/opt/buildhome/repo/frontend/pages/enquire.vue?macro=true";
import { default as indexCHaSsQQEon6GEKfHjTHLAXvTsB2zwL93W346bTFjTkcMeta } from "/opt/buildhome/repo/frontend/pages/campaigns/index.vue?macro=true";
import { default as _91slug_93pr1kYrFa1jrFr56LUeBKzPjzWBJaH36X_45Vj_4507f_45v7gMeta } from "/opt/buildhome/repo/frontend/pages/campaigns/[slug].vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/opt/buildhome/repo/frontend/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexTKHtD1lM1nWijPiNYDYA0NK2kgXJZ7rYFv1G6ns9_poMeta || {},
    component: () => import("/opt/buildhome/repo/frontend/pages/index.vue")
  },
  {
    name: "quote",
    path: "/quote",
    meta: quotekmRpIEOXb92wuFy0nNYYmbweRERxJgRGkrXBcFyxr2gMeta || {},
    component: () => import("/opt/buildhome/repo/frontend/pages/quote.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/opt/buildhome/repo/frontend/pages/[slug].vue")
  },
  {
    name: "enquire",
    path: "/enquire",
    component: () => import("/opt/buildhome/repo/frontend/pages/enquire.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    meta: indexCHaSsQQEon6GEKfHjTHLAXvTsB2zwL93W346bTFjTkcMeta || {},
    component: () => import("/opt/buildhome/repo/frontend/pages/campaigns/index.vue")
  },
  {
    name: "campaigns-slug",
    path: "/campaigns/:slug()",
    component: () => import("/opt/buildhome/repo/frontend/pages/campaigns/[slug].vue")
  }
]